import { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { CrossIcon } from 'assets/icons';
import { classnames } from 'helpers/utils';
import styles from './center-modal.module.scss';

interface CenterModalProps {
  onClose: () => void;
  children: React.ReactNode;
  className?: string;
  // Phones: the whole screen rather than a card, for dialogs that hold a
  // whole creator (a camera, a recorder, the note editor), as the mobile app
  // opens them.
  fullScreenOnPhone?: boolean;
}

export const CenterModal = ({
  onClose,
  children,
  className = '',
  fullScreenOnPhone = false,
}: CenterModalProps) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  return ReactDOM.createPortal(
    <div
      className={classnames(styles.overlay, {
        [styles.fullScreenOnPhone]: fullScreenOnPhone,
      })}
      role="presentation"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className={classnames(styles.card, className)}>
        <button
          type="button"
          className={styles.close}
          onClick={onClose}
          aria-label="Close"
        >
          <CrossIcon />
        </button>
        {children}
      </div>
    </div>,
    document.getElementById('modal') as HTMLElement,
  );
};
